import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Inventory from 'components/sales/formSection/editPostSaleApt/materialHardwareSection/inventory';

const MaterialHardware = ({
  data,
  handleValue,
  handleGatesData,
  handleProductData,
  getMaterial,
  getMateriaById,
  getBrandById,
  getBrand,
  prefilledData,
  editProduct=false,
  commData
}) => {
  const { materialHardwareRequired } = data;
  const MaterialInputs = {
    materialHardwareReq1: '',
  };
  const [materialData, setMaterialData] = useState(MaterialInputs);
  const [isMaterialRequired, setIsMaterialRequired] = useState('');
// console.log("BBBBB",prefilledData);
  useEffect(() => {
    if (
      prefilledData?.material_hardware !== undefined &&
      prefilledData?.material_hardware !== null
    ) {
      const {
        category,
        material
      } = prefilledData?.material_hardware;
      
      setTimeout(() => {
        if (material != '' || category != '') {
          setMaterialData({ materialHardwareReq1: {id: "yes", value: "Yes"} });
          setIsMaterialRequired('Yes');
        } else {
          setMaterialData({ materialHardwareReq1: {id: "no", value: "No"} });
          setIsMaterialRequired('No');
        }
      }, 200);

    }
  }, [prefilledData]);

  useEffect(() => {
    const materialObj = {
      materialHardwareReq: materialData.materialHardwareReq1.id,
    };
    console.log(materialData.materialHardwareReq1.id);
    const isNotEmpty = handleValidateObj(materialObj);
    if (isNotEmpty !== false) {
      handleValue({
        materialHardwareReq: materialData.materialHardwareReq1?.id,
      });
    } else {
      handleValue(null);
    }
  }, [materialData]);

  return (
    <Fragment>
      <FormSection title={localization.materialHardware}>
        <DropDownInput
          getIdValue={(val) => setMaterialData({ materialHardwareReq1: val })}
          data={materialHardwareRequired}
          label={localization.materialHardwareReq}
          required
          isStarRequired={true}
          errorMsg={localization.requiredmaterialHardwareReq}
          value={isMaterialRequired}
        />
      </FormSection>
      {materialData.materialHardwareReq1?.value?.toLowerCase() === 'yes' ? (
        <Fragment>
          <Inventory
            data={data}
            handleGatesData={handleGatesData}
            handleProductData={handleProductData}
            getMaterial={getMaterial}
            getMateriaById={getMateriaById}
            prefilledData={prefilledData}
            editProduct = {editProduct}
            getBrand={getBrand}
            getBrandById={getBrandById}
            commData={commData}
          />
        </Fragment>
      ) : null}
    </Fragment>
  );
};
MaterialHardware.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default MaterialHardware;
